(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Inputmask", [], factory);
	else if(typeof exports === 'object')
		exports["Inputmask"] = factory();
	else
		root["Inputmask"] = factory();
})(this, function() {
return 